import { apiService } from "./apiService";
import { IRequestGeoSearch, IResponseGeoSearch, ISearchRequest, IManualSearchRequest } from "../types/geoSearch";

export const GeoSearchService = {
  search: (searchOptions: ISearchRequest) => {
    return apiService.post("/api/geo-search/search", { searchOptions }).then((res) => {
      const { data } = res;
      return res.status === 200 && data;
    });
  },
  manualSearch: (searchOptions: IManualSearchRequest) => {
    return apiService.post("/api/geo-search/manualSearch", { searchOptions }).then((res) => {
      const { data } = res;
      return res.status === 200 && data;
    });
  },
  get: (request: IRequestGeoSearch): Promise<IResponseGeoSearch> => {
    return apiService.post(`/api/geo-search/all`, { request }).then((res) => {
      const { data } = res;
      return res.status === 200 && data;
    });
  },
  getById: (searchId: string): Promise<any> => {
    return apiService.get(`/api/geo-search/${searchId}`).then((res) => {
      const { data } = res;
      return res.status === 200 && data;
    });
  },
  getPhotoById: (photoId: string): Promise<any> => {
    return apiService.get(`/api/geo-search/photo/${photoId}`).then((res) => {
      const { data } = res;
      return res.status === 200 && data;
    });
  },
  getResultImages: (searchId: string, page: number, size: number): Promise<any> => {
    return apiService.post("/api/geo-search/images", { searchId, page, size }).then((res) => {
      const { data } = res;
      return res.status === 200 && data;
    });
  },
  getProcessedImages: (searchId: string) => {
    return apiService.get(`/api/geo-search/processedImages/${searchId}`).then((res) => {
      const { data } = res;
      return res.status === 200 && data;
    });
  },
  updateSearchName: (searchId: string, searchName: string) => {
    return apiService.post(`api/geo-search/updateName/${searchId}`, { searchName }).then((res) => {
      const { data } = res;
      return res.status === 200 && data;
    });
  }
};
